import React from "react";
import { NewPostulationForm } from '@rankmi/ats-app'

const FormPage = ({ applicant_form_token, tenant_id }) => {
  return (
    <NewPostulationForm applicantFormToken={applicant_form_token} tenantId={tenant_id} />
  )
}
export default FormPage
